import "./NavBar.css";
import EmailIcon from "./assets/social-media-icons/email_32x32.png";

// Access environment variables via process.env
//const mieroNFTAddress = process.env.REACT_APP_MAINNET_MiEMarketPlaceContract;
const mieroNFTAddress = process.env.NODE_ENV === 'development' 
  ? process.env.REACT_APP_SEPOLIA_Contract 
  : process.env.REACT_APP_MAINNET_Contract;

// Create the Etherscan URL based on environment
const etherscanBaseUrl = process.env.NODE_ENV === 'development'
  ? 'https://sepolia.etherscan.io/token/'
  : 'https://etherscan.io/token/';

const etherscanUrl = `${etherscanBaseUrl}${mieroNFTAddress}`;

// Add props to receive wallet-related functions and state
const NavBar = ({ accounts, connectWallet, disconnectWallet, formatWalletAddress }) => {
    return (
        <div className="navbar">
            {/* Left Side - Social Media Icons */}
            <div className="navbar-left">
                <a href={etherscanUrl} target="_blank" rel="noopener noreferrer">
                    <img src={EmailIcon} alt="Email Icon" className="social-icon" />
                </a>
            </div>

            {/* Center - Navigation Links */}
            <div className="navbar-center">
                <a href="/" className="nav-link">Mint</a>
                <a href="/tokenomics" className="nav-link">Tokenomics</a>
            </div>

            {/* Right Side - Connect/Disconnect Button */}
            <div className="navbar-right">
                <div className="connect-section">
                    {accounts?.length > 0 ? (
                        <>
                            <button className="connect-button disconnect" onClick={disconnectWallet}>
                                Disconnect
                            </button>
                            <div className="wallet-address">
                                {formatWalletAddress(accounts[0])}
                            </div>
                        </>
                    ) : (
                        <button className="connect-button" onClick={connectWallet}>
                            Connect
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NavBar;
